import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "BMI",
    isNumber: true,
    isSum: true,
  },
];

export const CaseStatusToBMI = {
  label: "案件狀態 vs BMI",
  key: "CaseStatusToBMI",
  path: "BMI/CaseStatusToBMI",
  api: "TCS_V_BMICaseClosedV",
  render: (options) => <Diagram.BMI.CaseStatusToBMI {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "案件狀態",
      field: "案件狀態",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
